import React from "react";

import CSVSVG from "../../assets/csv.svg";

const CSVIcon = () => <img className="h-4 w-4" src={CSVSVG} />;

export default CSVIcon;
